module.exports = __webpack_public_path__ + "img/round3.0c150879.svg";